@if (data) {
  <nav aria-label="Page navigation example" style="box-shadow: none;">
    <pagination-template #pt="paginationApi" (pageChange)="onPageChange($event)"
      (pageBoundsCorrection)="p = $event">
      <ul class="pagination bottom-root-pagination">
        <li class="page-item first" [class.disabled]="pt?.isFirstPage()" [class.current]="pt?.isFirstPage()">
          <a class="page-link" href="javascript:void(0)" (click)="pt?.setCurrent(1)">First Page
          </a>
        </li>
        @if (!pt?.isFirstPage()) {
          <li class="page-item" [class.disabled]="pt?.isFirstPage()">
            <a class="page-link next-prev-a" href="javascript:void(0)" (click)="!pt?.isFirstPage() && pt?.previous()"
              aria-label="Previous">
              <span class="ellipsis next-prev"><</span>
            </a>
          </li>
        }
        @for (page of pt?.pages; track trackByIndex($index); let last = $last) {
          @if (page.value !== 1 && !last) {
            <li class="page-item" [class.current]="pt?.getCurrent() === page.value">
              <a class="page-link" href="javascript:void(0)"  [ngClass]="{
                'ellipsis': page.label === '...'}"
                (click)="pt?.getCurrent() !== page.value && pt?.setCurrent(page.value)">
                {{ page.label === '...' ? (page.value < pt?.getCurrent() ? '<<' : '>>') : page.label }}
              </a>
            </li>
          }
        }
        @if (!pt?.isLastPage()) {
          <li class="page-item" [class.disabled]="pt?.isLastPage()">
            <a class="page-link next-prev-a" href="javascript:void(0)" (click)="!pt?.isLastPage() && pt?.next()"
              aria-label="Next">
              <span class="ellipsis next-prev">></span>
            </a>
          </li>
        }
        <li class="page-item last" [class.disabled]="pt?.isLastPage()" [class.current]="pt?.isLastPage()">
          <a class="page-link" href="javascript:void(0)" (click)="pt?.setCurrent($safeNavigationMigration(pt?.getLastPage()))">Last Page
          </a>
        </li>
      </ul>
    </pagination-template>
  </nav>
}
